import { useCapabilities } from "src/hooks/useCapabilities";
import { useIsAgentsEnabled } from "src/hooks/useIsAgentsEnabled";
import { useIsCaseManagementEnabled } from "src/hooks/useIsCaseManagementEnabled";
import { useWorkspaceFeatureGates } from "src/hooks/useWorkspaceFeatureGates";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";

export const useIsSidebarLayout = (): boolean => {
  const { entitiesEnabled, featuresEventsEnabled } = useWorkspaceFeatureGates();
  const { isEnabled: isCaseManagementEnabled } = useIsCaseManagementEnabled();
  const { isEnabled: isAgentsEnabled } = useIsAgentsEnabled();
  const capabilities = useCapabilities();
  return (
    entitiesEnabled ||
    featuresEventsEnabled ||
    (isCaseManagementEnabled && capabilities.cases.canAccess) ||
    (isAgentsEnabled &&
      capabilities.agents.canAccess &&
      isFeatureFlagEnabled(FEATURE_FLAGS.agents))
  );
};
